import { useState, useEffect, useRef } from "react";
import "./CountDown.css";

const CountDown = ({ duration, onUnlock }) => {
  const [timeLeft, setTimeLeft] = useState(duration);
  const unlockedRef = useRef(false);
  const onUnlockRef = useRef(onUnlock);

  useEffect(() => {
    onUnlockRef.current = onUnlock;
  }, [onUnlock]);

  useEffect(() => {
    setTimeLeft(duration);
    unlockedRef.current = false;
  }, [duration]);

  useEffect(() => {
    if (timeLeft <= 0) {
      if (!unlockedRef.current) {
        unlockedRef.current = true;
        onUnlockRef.current?.();
      }
      return undefined;
    }

    const interval = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft]);

  const safeDuration = duration > 0 ? duration : 1;
  const progress = Math.max(0, Math.min(100, (timeLeft / safeDuration) * 100));

  return (
    <div className="timer-container" aria-live="polite">
      <div className="timer-text">
        {timeLeft > 0
          ? `${timeLeft}s remaining`
          : "You can continue now"}
      </div>
      <div
        className="progress-bar"
        role="progressbar"
        aria-valuenow={timeLeft}
        aria-valuemin={0}
        aria-valuemax={duration}
      >
        <div className="progress" style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
};

export default CountDown;
